const columnsWidth = {
  type: '78px',
  status: '8%',
  doc_number: '7%',
  createDate: '8%',
  DocExecuter: '13%',
  ResponsibleWorker: '13%',
  topic: '18%',
  DoneDate: '7%',
  deadlineDate: '7%',
  adresses: '14%',
  DocChange: '50px',
  orgs: '14%',
  // related_objects: '15%'
};

export default columnsWidth;
